import * as actionTypes from "./actionTypes";
import {SearchState, ReduxAction} from '../type.d';
import {normalizeSubscriptions, getQuerySubscriptions, normalizeSearchResults} from "../helpers/normalizeResults";

const initialState = {
  gmailLoginState: {
    pending: false,
    data: null,
    err: null,
  },
  slackLoginState: {
    pending: false,
    data: null,
    err: null,
  },
  subscriptionsState: {
    pending: false,
    data: null,
    err: null,
    normalizedData: null,
    slackMembers: null,
    querySubscriptions: null,
  },
  searchField: '',
  searchData: {
    pending: false,
    data: null,
    err: null,
    normalizedSearchData: null,
  },
  getBookmarksData: {
    pending: false,
    data: null,
    err: null,
  },
  postBookmarkData: {
    pending: false,
    data: null,
    err: null
  },
  deleteBookmarkData: {
    pending: false,
    data: null,
    err: null
  },
  feedbackData: {
    pending: false,
    data: null,
    err: null
  },
  permalinkData: {
    pending: false,
    data: null,
    err: null
  },
  deleteUserData: {
    pending: false,
    data: null,
    err: null
  },
  dissconnectAccountData: {
    pending: false,
    data: null,
    err: null
  },
  connectionLinksState: {
    pending: false,
    data: null,
    err: null,
  }
}

const searchReducer = (
  state: SearchState = initialState,
  action: ReduxAction
): SearchState => {
  switch (action.type) {
    case actionTypes.GET_GMAIL_LOGIN_LINK_FETCHED:
      return ({
        ...state,
        gmailLoginState: {
          ...state.gmailLoginState,
          pending: true,
        }
      });
    case actionTypes.GET_GMAIL_LOGIN_LINK_SUCCESS:
      return ({
        ...state,
        gmailLoginState: {
          ...state.gmailLoginState,
          pending: false,
          data: action.payload,
        }
      });
    case actionTypes.GET_GMAIL_LOGIN_LINK_FAILED:
      return ({
        ...state,
        gmailLoginState: {
          ...state.gmailLoginState,
          pending: false,
          err: action.payload,
        }
      });
    case actionTypes.GET_SLACK_LOGIN_LINK_FETCHED:
      return ({
        ...state,
        slackLoginState: {
          ...state.slackLoginState,
          pending: true,
        }
      });
    case actionTypes.GET_SLACK_LOGIN_LINK_SUCCESS:
      return ({
        ...state,
        slackLoginState: {
          ...state.slackLoginState,
          pending: false,
          data: action.payload,
        }
      });
    case actionTypes.GET_SLACK_LOGIN_LINK_FAILED:
      return ({
        ...state,
        slackLoginState: {
          ...state.slackLoginState,
          pending: false,
          err: action.payload,
        }
      });
    case actionTypes.GET_CONNECTION_LINKS_SUCCESS:
      return ({
        ...state,
        connectionLinksState: {
          ...state.connectionLinksState,
          pending: false,
          data: action.payload,
        }
      });
    case actionTypes.GET_CONNECTION_LINKS_ERROR:
      return ({
        ...state,
        connectionLinksState: {
          ...state.connectionLinksState,
          pending: false,
          data: action.payload,
          err: action.payload,
        }
      });
    case actionTypes.GET_SUBSCRIPTIONS_FETCHED:
      return ({
        ...state,
        subscriptionsState: {
          ...state.subscriptionsState,
          pending: true,
        }
      });
    case actionTypes.GET_SUBSCRIPTIONS_SUCCESS:
      let normalizedData = {}, querySubscriptions = [];
      try {
        normalizedData = normalizeSubscriptions(action.payload || []);
        querySubscriptions = getQuerySubscriptions(normalizedData);
      } catch (err) {
        console.log(err);
      }

      return {
        ...state,
        subscriptionsState: {
          ...state.subscriptionsState,
          pending: false,
          data: action.payload,
          normalizedData,
          slackMembers: action.payload.slackMembers || [],
          querySubscriptions,
        },
      };
    case actionTypes.GET_SUBSCRIPTIONS_FAILED:
      return ({
        ...state,
        subscriptionsState: {
          ...state.subscriptionsState,
          pending: false,
          err: action.payload,
        }
      });
    case actionTypes.SEARCH_FIELD_CHANGED:
      return ({
        ...state,
        searchField: action.payload,
      });
    case actionTypes.SEARCH_DATA_FETCHED:
      return ({
        ...state,
        searchData: {
          ...state.searchData,
          data: null,
          pending: true,
        }
      });
    case actionTypes.SEARCH_DATA_SUCCESS:
      const { payload } = action;
      return ({
        ...state,
        searchData: {
          ...state.searchData,
          pending: false,
          data: payload || null,
          //normalizedSearchData: normalizeSearchResults(payload),
        }
      });
    case actionTypes.SEARCH_DATA_FAILED:
      return ({
        ...state,
        searchData: {
          ...state.searchData,
          pending: false,
          data: null,
          normalizedSearchData: null,
          err: action.payload,
        }
      });
    case actionTypes.GET_BOOKMARKS_FETCHED:
      return ({
        ...state,
        getBookmarksData: {
          ...state.getBookmarksData,
          pending: true,
        }
      });
    case actionTypes.GET_BOOKMARKS_SUCCESS:
      return ({
        ...state,
        getBookmarksData: {
          ...state.getBookmarksData,
          pending: false,
          data: action.payload,
        }
      });
    case actionTypes.GET_BOOKMARKS_FAILED:
      return ({
        ...state,
        getBookmarksData: {
          ...state.getBookmarksData,
          pending: false,
          err: action.payload,
        }
      });
    case actionTypes.POST_BOOKMARK_FETCHED:
      return ({
        ...state,
        postBookmarkData: {
          ...state.postBookmarkData,
          pending: true,
        }
      });
    case actionTypes.POST_BOOKMARK_SUCCESS:
      return ({
        ...state,
        postBookmarkData: {
          ...state.postBookmarkData,
          pending: false,
          data: action.payload,
        }
      });
    case actionTypes.POST_BOOKMARK_FAILED:
      return ({
        ...state,
        postBookmarkData: {
          ...state.postBookmarkData,
          pending: false,
          err: action.payload,
        }
      });
    case actionTypes.DELETE_BOOKMARK_FETCHED:
      return ({
        ...state,
        deleteBookmarkData: {
          ...state.deleteBookmarkData,
          pending: true,
        }
      });
    case actionTypes.DELETE_BOOKMARK_SUCCESS:
      return ({
        ...state,
        deleteBookmarkData: {
          ...state.deleteBookmarkData,
          pending: false,
          data: action.payload,
        }
      });
    case actionTypes.DELETE_BOOKMARK_LOCALY:
      return ({
        ...state,
        getBookmarksData: {
          ...state.getBookmarksData,
          // @ts-ignore
          data: {
            ...state.getBookmarksData.data,
            response: action.payload,
          }
        }
      });
    case actionTypes.DELETE_BOOKMARK_FAILED:
      return ({
        ...state,
        deleteBookmarkData: {
          ...state.deleteBookmarkData,
          pending: false,
          err: action.payload,
        }
      });
    case actionTypes.FEEDBACK_DATA_FETCHED:
      return ({
        ...state,
        feedbackData: {
          ...state.feedbackData,
          pending: true,
        }
      });
    case actionTypes.FEEDBACK_DATA_SUCCESS:
      return ({
        ...state,
        feedbackData: {
          ...state.feedbackData,
          pending: false,
          data: action.payload,
        }
      });
    case actionTypes.FEEDBACK_DATA_FAILED:
      return ({
        ...state,
        feedbackData: {
          ...state.feedbackData,
          pending: false,
          err: action.payload,
        }
      });
    case actionTypes.PERMALINK_DATA_FETCHED:
      return ({
        ...state,
        permalinkData: {
          ...state.permalinkData,
          pending: true,
        }
      });
    case actionTypes.PERMALINK_DATA_SUCCESS:
      return ({
        ...state,
        permalinkData: {
          ...state.permalinkData,
          pending: false,
          data: action.payload,
        }
      });
    case actionTypes.PERMALINK_DATA_FAILED:
      return ({
        ...state,
        permalinkData: {
          ...state.permalinkData,
          pending: false,
          err: action.payload,
        }
      });
    case actionTypes.DELETE_USER_FETCHED:
      return ({
        ...state,
        permalinkData: {
          ...state.permalinkData,
          pending: true,
        }
      });
    case actionTypes.DELETE_USER_SUCCESS:
      return ({
        gmailLoginState: {
          pending: false,
          data: null,
          err: null,
        },
        slackLoginState: {
          pending: false,
          data: null,
          err: null,
        },
        connectionLinksState: {
          pending: false,
          data: null,
          err: null,
        },
        subscriptionsState: {
          pending: false,
          data: null,
          err: null,
          normalizedData: null,
          slackMembers: null,
          querySubscriptions: null,
        },
        searchField: '',
        searchData: {
          pending: false,
          data: null,
          err: null,
          normalizedSearchData: null,
        },
        getBookmarksData: {
          pending: false,
          data: null,
          err: null,
        },
        postBookmarkData: {
          pending: false,
          data: null,
          err: null
        },
        deleteBookmarkData: {
          pending: false,
          data: null,
          err: null
        },
        feedbackData: {
          pending: false,
          data: null,
          err: null
        },
        permalinkData: {
          pending: false,
          data: null,
          err: null
        },
        deleteUserData: {
          pending: false,
          data: action.payload,
          err: null
        },
        dissconnectAccountData: {
          pending: false,
          data: null,
          err: null
        }
      });
    case actionTypes.DELETE_USER_FAILED:
      return ({
        ...state,
        deleteUserData: {
          ...state.deleteUserData,
          pending: false,
          err: action.payload,
        }
      });
    case actionTypes.DISSCONNECT_ACCOUNT_FETCHED:
      return ({
        ...state,
        dissconnectAccountData: {
          ...state.dissconnectAccountData,
          pending: true,
        }
      });
    case actionTypes.DISSCONNECT_ACCOUNT_SUCCESS:
      return ({
        ...state,
        dissconnectAccountData: {
          ...state.dissconnectAccountData,
          pending: false,
          data: action.payload,
        }
      });
    case actionTypes.DISSCONNECT_ACCOUNT_FAILED:
      return ({
        ...state,
        dissconnectAccountData: {
          ...state.dissconnectAccountData,
          pending: false,
          err: action.payload,
        }
      });
      case actionTypes.SIGN_OUT:
      return ({
        gmailLoginState: {
          pending: false,
          data: null,
          err: null,
        },
        slackLoginState: {
          pending: false,
          data: null,
          err: null,
        },
        connectionLinksState: {
          pending: false,
          data: null,
          err: null,
        },
        subscriptionsState: {
          pending: false,
          data: null,
          err: null,
          normalizedData: null,
          slackMembers: null,
          querySubscriptions: null,
        },
        searchField: '',
        searchData: {
          pending: false,
          data: null,
          normalizedSearchData: null,
          err: null,
        },
        getBookmarksData: {
          pending: false,
          data: null,
          err: null,
        },
        postBookmarkData: {
          pending: false,
          data: null,
          err: null
        },
        deleteBookmarkData: {
          pending: false,
          data: null,
          err: null
        },
        feedbackData: {
          pending: false,
          data: null,
          err: null
        },
        permalinkData: {
          pending: false,
          data: null,
          err: null
        },
        deleteUserData: {
          pending: false,
          data: action.payload,
          err: null
        },
        dissconnectAccountData: {
          pending: false,
          data: null,
          err: null
        }
      });
    default:
      return {...state};
  }
}

export default searchReducer;